import React, { useState } from "react";
import { db, storage } from "../firebaseConfig";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";

const BuyTicket = () => {
  const [buyerName, setBuyerName] = useState("");
  const [buyerEmail, setBuyerEmail] = useState("");
  const [buyerContact, setBuyerContact] = useState("");
  const [ticketCount, setTicketCount] = useState("");
  const [codeInput, setCodeInput] = useState("");
  const [paymentMethod, setPaymentMethod] = useState("GCash");
  const [proof, setProof] = useState(null);
  const [totalPrice, setTotalPrice] = useState(600.0);

  const validCodes = ["Facilitator", "No Shirt"];

  const updateTotal = (code, count) => {
    const isSpecial = validCodes.includes(code.trim());
    const parsed = parseInt(count);

    if (isNaN(parsed) || parsed <= 0) {
       setTotalPrice(0);
       return;
    }

    if (isSpecial) {
       setTicketCount(1);
       setTotalPrice(500.0);
    }  else {
       setTotalPrice(parsed * 600.0);
    }
 };

  const handleCodeChange = (e) => {
    const value = e.target.value;
    setCodeInput(value);
    updateTotal(value, ticketCount);
  };

  const handleCountChange = (e) => {
    const count = e.target.value;
    setTicketCount(count);
    updateTotal(codeInput, count);
  };

  const handleFileChange = (e) => {
    if (e.target.files[0]) setProof(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!proof) return alert("Please upload proof of payment.");
    if (!buyerContact.match(/^\d+$/)) return alert("Contact number must be numeric.");

    const isSpecialCode = validCodes.includes(codeInput.trim());
    if (isSpecialCode && parseInt(ticketCount) !== 1) {
      alert("Only 1 ticket is allowed for this code.");
      return;
    }

    const fileName = `${buyerEmail}_${new Date().getTime()}`;
    const storageRef = ref(storage, `proofOfPayment/${fileName}`);
    const uploadTask = uploadBytesResumable(storageRef, proof);
    const finalPrice = isSpecialCode ? 500.0 : parseInt(ticketCount) * 600.0;

    uploadTask.on(
      "state_changed",
      null,
      (error) => {
        console.error("Upload failed:", error);
        alert("Upload failed. Please try again.");
      },
      async () => {
        try {
          const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);

        for (let i = 0; i < ticketCount; i++) {
          await addDoc(collection(db, "ticketPurchases"), {
          buyerName,
          buyerEmail,
          buyerContact,
          ticketCount: 1, // 1 ticket per document
          totalPrice: (finalPrice / ticketCount).toFixed(2), // divide total price per ticket
          paymentMethod,
          codeInput: codeInput.trim(),
          proofOfPayment: downloadURL,
          paymentStatus: "pending",
          createdAt: serverTimestamp(),
          });
          }


          alert("✅ Ticket submitted! Please wait for verification. Your ticket will be sent to your email!");

          setBuyerName("");
          setBuyerEmail("");
          setBuyerContact("");
          setTicketCount(1);
          setCodeInput("");
          setProof(null);
          setPaymentMethod("GCash");
          setTotalPrice(600.0);
        } catch (firestoreError) {
          console.error("Error saving to Firestore:", firestoreError);
          alert("Upload successful, but saving ticket failed. Please message CCF Dipolog Facebook Page");
        }
      }
    );
  };

  
  return (
  <div className="page buyTicket-background">
    <div style={{ maxWidth: "600px", margin: "0 auto", padding: "40px", color: "white" }}>
      <h2 style={{ fontWeight: "bold", fontSize: "35px", textAlign: "center", marginBottom: "30px" }}>Buy Ticket</h2>

      <form onSubmit={handleSubmit}>
        <div style={{ fontSize: "20px", marginBottom: "20px", textAlign: "center" }}>
          <label>Complete Name:</label><br />
          <input
            type="text"
            value={buyerName}
            onChange={(e) => setBuyerName(e.target.value)}
            required
            style={{ padding: "10px", width: "70%", borderRadius: "25px", fontSize: "17px", textAlign: "center", backgroundColor: "#b7f6fc" }}
          />
        </div>

        <div style={{ fontSize: "20px", marginBottom: "20px", textAlign: "center" }}>
          <label>Email Address:</label><br />
          <input
            type="email"
            value={buyerEmail}
            onChange={(e) => setBuyerEmail(e.target.value)}
            required
            style={{ padding: "10px", width: "70%", borderRadius: "25px", fontSize: "17px", textAlign: "center", backgroundColor: "#b7f6fc" }}
          />
        </div>

        <div style={{ fontSize: "20px", marginBottom: "20px", textAlign: "center" }}>
          <label>Contact Number:</label><br />
          <input
            type="text"
            value={buyerContact}
            onChange={(e) => setBuyerContact(e.target.value)}
            required
            style={{ padding: "10px", width: "70%", borderRadius: "25px", fontSize: "17px", textAlign: "center", backgroundColor: "#b7f6fc" }}
          />
        </div>

        <div style={{ fontSize: "20px", marginBottom: "20px", textAlign: "center" }}>
          <label>How many tickets?</label><br />
          <input
            type="number"
            min="1"
            value={ticketCount}
	    onChange={handleCountChange}
            required
            style={{ padding: "10px", width: "70%", borderRadius: "25px", fontSize: "17px", textAlign: "center", backgroundColor: "#b7f6fc" }}
          />
        </div>

        <div style={{ fontSize: "20px", marginBottom: "20px", textAlign: "center" }}>
          <label>Enter Special Code (If Any):</label><br />
          <input
            type="text"
            value={codeInput}
            onChange={handleCodeChange}
            placeholder=""
            style={{ padding: "10px", width: "70%", borderRadius: "25px", fontSize: "17px", textAlign: "center", backgroundColor: "#b7f6fc" }}
          />
        </div>

	<div style={{ textAlign: "center", marginTop: "40px" }}>
  	  <p style={{ fontSize: "25px", fontWeight: "bold", color: "#ffc300" }}>
           Total Amount: ₱{totalPrice.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
  	  </p>
        </div>

        <div style={{ fontSize: "20px", marginBottom: "20px", textAlign: "center" }}>
          <label>Mode of Payment</label><br />
          <select
	    id="paymentMethod"
            value={paymentMethod}
            onChange={(e) => setPaymentMethod(e.target.value)}
            style={{ padding: "10px", width: "35%", borderRadius: "25px", fontSize: "17px", textAlign: "center", backgroundColor: "#b7f6fc" }}
          >
            <option value="GCash">GCash</option>
            <option value="Bank Transfer">Bank Transfer</option>
          </select>
        </div>

       {paymentMethod === "GCash" && (
    	<div style={{ textAlign: "center", marginTop: "20px", color: "#e9fafa" }}>
          <p style={{ marginBottom: "3px" }}><strong>Pay via Gcash:</strong></p>
          <p style={{ marginTop: "2px" }}>Go to Bank Transfer to:</p>
          <p style={{ marginBottom: "4px" }}><strong>Security Bank Corporation</strong></p>
          <p style={{ marginTop: "3px" }}>Account Name: Christ's Commission Foundation, Inc.</p>
	  <p style={{ marginBottom: "3px" }}>Account Number: 0477009648029</p>
        </div>
       )}
     
 
       {paymentMethod === "Bank Transfer" && (
        <div style={{ textAlign: "center", marginTop: "20px", color: "#e9fafa" }}>
          <p style={{ marginTop: "2px" }}>Payment Details</p>
          <p style={{ marginBottom: "4px" }}><strong>Security Bank Corporation</strong></p>
          <p style={{ marginTop: "3px" }}>Christ's Commission Foundation, Inc.</p>
	  <p style={{ marginTop: "2px" }}>0477009648029</p>
       </div>
     )}

        <div style={{ fontSize: "20px", textAlign: "center", marginTop: "30px" }}>
          <label htmlFor="proof" style={{ display: "block", marginBottom: "20px" }}>
           Upload Proof of Payment:
          </label>
          <input
          type="file"
          id="proof"
          onChange={handleFileChange}
          accept="image/*,application/pdf"
          required
          style={{ display: "inline-block" }}
         />
        </div>

        <div style={{ textAlign: "center", marginTop: "30px" }}>
          <button type="submit" style={{ padding: "15px 20px", borderRadius: "20px", fontWeight: "bold", fontSize: "20px" }}>
            Submit Payment
          </button>
        </div>
      </form>
    </div>
  </div>
);
};

export default BuyTicket;
